// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/web-01.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
  font-family: 'League Spartan', sans-serif !important;
  color: #fff !important;
}

img{
  display: inline-block;
  max-width: 100%;
}

.main-inner-area{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})no-repeat top center;
  background-size: cover;
  background-attachment: fixed;
  padding-top: 83px;
}

.cms-page-wrapper {
  padding: 50px 0;
}

/* ///////////////////////////////////// */

header.main-header {
  /* background: linear-gradient(180deg, rgba(8, 179, 136, 0.15) 0%, rgba(22, 101, 192, 0.15) 100%); */
  background: linear-gradient(180deg, rgb(7 33 44) 0%, rgb(9 23 51) 100%);
  padding: 12px 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 111;
}

header.main-header .row {
  justify-content: space-between;
  align-items: center;
}

header.main-header .site-logo {
  width: 200px;
}

header.main-header .site-logo a {
  display: inline-block;
}

header.main-header .site-logo a img {
  max-width: 100%;
  max-height: 42px;
  object-fit: contain;
}
header.main-header .site-navbar {
  width: calc(100% - 200px);
}
header.main-header .site-navbar ul {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  justify-content: flex-end;
}
header.main-header .site-navbar ul li a{
  display: inline-block;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.80);
  font-size: 16px;
  font-weight: 500;
  padding: 12px;
  transition: all 0.2s;
}
header.main-header .site-navbar ul li a:hover{color: #08B388;}


.newsletter-form {
}
.newsletter-form form {
  position: relative;
  max-width: 450px;
  margin-top: 30px;
}
.newsletter-form form input {
  width: 100%;
  height: 50px;
  background: transparent;
  border: 1px solid #fff;
  outline: none;
  border-radius: 24px;
  color: #fff;
  font-size: 16px;
  padding: 0 25px;
}
.newsletter-form form button {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  background: #08b388;
  border: none;
  outline: none;
  color: #fff;
  font-size: 16px;
  padding: 0 20px;
  border-radius: 0px 25px 25px 0px;
}
.newsletter-form form p {
  margin: 10px 0px 0px;
  padding: 0px;
}

/* ////////////////////////////////////////////////////////////// */

.container {
  max-width: 1170px !important;
  width: 100%;
}

.section-seprator {
  text-align: center;
  border-top: solid 2px rgba(93, 95, 239, 0.20);
}

.section-seprator h4 {
  display: inline-block;
  margin: 0 0 0;
  border-radius: 4px;
  background: rgba(93, 95, 239, 0.20);
  color: #08B388;
  font-size: 20px;
  font-weight: 600;
  padding: 6px 22px;
}

.common-content-section {
  padding: 100px 0;
}

.common-content .label-tag {
  display: inline-flex;
  align-items: center;
  border-radius: 12px 12px 12px 0px;
  background: rgba(93, 95, 239, 0.20);
  color: #08B388;
  font-size: 20px;
  font-weight: 600;
  padding: 11px 20px 8px;
}

.common-content .label-tag img {
  margin-right: 6px;
  transform: translateY(-2px);
}

.common-content h1 {
  margin: 22px 0 0px;
  color: #D9D9D9;
  font-size: 40px;
  font-weight: 500;
  line-height: 1;
  max-width: 475px;
}

.common-content h2 {
  margin: 22px 0 0px;
  color: #D9D9D9;
  font-size: 36px;
  font-weight: 500;
  line-height: 1;
  max-width: 420px;
}

.common-content p {
  margin: 26px 0 0;
  color: #D9D9D9;
  font-family: League Spartan;
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: 1.2;
}

.common-content .site-btn {
  display: inline-block;
  text-decoration: none;
  font-weight: 500;
  font-size: 20px;
  color: #fff;
  border-radius: 12px;
  background: #08B388;
  line-height: 1.2;
  padding: 13px 20px 10px;
  margin-top: 30px;
  transition: all 0.4s;
}

.common-content .site-btn:hover{
  transform: scale(1.08);
}

.app-buttons {
  margin-top: 40px;
  display: flex;
  align-items: center;
}

.app-buttons a {
  display: inline-block;
  text-decoration: none;
  margin-right: 12px;
  transition: all 0.4s;
}

.app-buttons a:hover{
  transform: scale(1.08);
}

.app-buttons a:last-child{margin-right: 0;}

.app-buttons a img {
  max-width: 193px;
  width: 100%;
}

.app-slider-inner {
  width: 100%;
}

.app-slider-inner .container-fluid {
  max-width: 1400px;
  padding: 0 30px;
}

.app-slider-inner .slick-list {
  padding: 50px 0 !important;
}

.app-slider-text {
  padding-bottom: 50px;
  max-width: 1000px;
  margin: 0 auto;
}

.app-slider-text h2 {
  margin: 0 auto;
  color: #D9D9D9;
  font-size: 36px;
  font-weight: 500;
  line-height: 1;
  max-width: 548px;
}

.app-slider-text p {
  margin: 26px 0 0;
  color: #D9D9D9;
  font-family: League Spartan;
  font-size: 25px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.2;
}

.app-slider-wrapper {
  padding: 100px 0 100px;
}

.app-img-item {
  padding: 0 15px;
  text-align: center;
}
.app-img-item img{
  display: inline-block !important;
  transition: all 0.4s;
}

.app-slider-inner .slick-center .app-img-item img{
  transform: scale(1.15);
}

/* ////////////////////////////////////////////////////// */

footer.main-footer {
  background: #0C141D;
  padding: 60px 0;
}

.footer-cl-01 {
  max-width: 400px;
}

.footer-cl-01 img {}

.footer-cl-01 p {
  color: rgba(255, 255, 255, 0.80);
  font-size: 16px;
  font-weight: 300;
  line-height: 1.3;
  margin: 20px 0 0;
}

.footer-cl-02 {}

.footer-cl-02 ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.footer-cl-02 ul li {
  padding-bottom: 8px;
}

.footer-cl-02 ul li a {
  display: inline-block;
  text-decoration: none;
  font-size: 16px;
  color: #fff;
  font-weight: 300;
  line-height: 1.2;
  padding: 0;
  transition: all 0.2s;
}

.footer-cl-02 ul li a:hover{color: #08B388;}

footer.main-footer h3 {
  color: #fff;
  margin: 0 0 0;
  font-size: 40px;
  line-height: 1;
  font-weight: 500;
  padding-bottom: 20px;
}

.footer-cl-03 {}

.footer-cl-03 ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.footer-cl-03 ul li {
  padding-bottom: 11px;
}

.footer-cl-03 ul li a {
  display: inline-block;
}

.footer-cl-03 ul li a img {
  max-width: 160px;
}

.footer-copyright {
  background: #0C141D;
  border-top: 2px solid #06091a;
  padding: 20px 0;
}

.footer-copyright p {
  margin: 0 0 0;
  color: rgba(255, 255, 255, 0.80);
  font-weight: 300;
  font-size: 14px;
}

@media (max-width: 991.98px){

  .common-content-section {
    padding: 60px 0;
    text-align: center;
  }
  .common-content {
    padding-top: 40px;
  }
  .common-large-img img {
    max-width: 600px;
    width: 100%;
  }
  .common-content h1,
  .common-content h2,
  .footer-cl-01{
    max-width: 100%;
  }
  .app-buttons{
    justify-content: center;
  }
  .footer-cl-02,
  .footer-cl-03{
    padding-top: 40px;
  }
  .app-slider-wrapper {
    padding: 60px 0 60px;
  }

}

@media (max-width: 767.98px){

  .common-content h1,
  .common-content h2,
  .app-slider-text h2{
    font-size: 32px;
  }
  .app-slider-text p{
    font-size: 18px;
  }
  header.main-header .site-navbar{
    position: fixed;
    top: 0;
    left: -300px;
    bottom: 0;
    width: 300px;
    z-index: 555;
    height: 100%;
    background: #000;
    padding-top: 40px;
    transition: all 0.4s;
  }
  header.main-header .site-navbar.active{
    left: 0;
  }
  header.main-header .site-navbar ul{
    display: block;
  }
  header.main-header .mobile-menu-close {
    display: block !important;
    position: absolute;
    top: 10px;
    right: 12px;
    color: #fff;
    cursor: pointer;
  }

  .mobile-menu-close svg {
    width: 20px;
    height: 20px;
  }
  header.main-header .mobile-menu-button{
    display: block !important;
    width: calc(100% - 200px);
    text-align: right;
    cursor: pointer;
    color: #fff;
  }
  header.main-header .mobile-menu-button svg{
    width: 25px;
    height: 25px;
  }
  header.main-header .site-navbar ul li a{
    display: block;
  }

}

@media (max-width: 576.98px){

  

}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uEAAkE;EAClE,sBAAsB;EACtB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,0CAA0C;;AAE1C;EACE,oGAAoG;EACpG,uEAAuE;EACvE,eAAe;EACf,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;AACA,8CAA8C,cAAc,CAAC;;;AAG7D;AACA;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA,mEAAmE;;AAEnE;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;EACjC,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0BAA0B,eAAe,CAAC;;AAE1C;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,2DAA2D;;AAE3D;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;;AAEnB;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA,4BAA4B,cAAc,CAAC;;AAE3C;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,eAAe;;AAEf;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;;AAEF;;AAEA;;EAEE;;;IAGE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,MAAM;IACN,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,OAAO;EACT;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;EAChB;;AAEF;;AAEA;;;;AAIA","sourcesContent":["body{\n  font-family: 'League Spartan', sans-serif !important;\n  color: #fff !important;\n}\n\nimg{\n  display: inline-block;\n  max-width: 100%;\n}\n\n.main-inner-area{\n  background: url('../public/images/web-01.jpg')no-repeat top center;\n  background-size: cover;\n  background-attachment: fixed;\n  padding-top: 83px;\n}\n\n.cms-page-wrapper {\n  padding: 50px 0;\n}\n\n/* ///////////////////////////////////// */\n\nheader.main-header {\n  /* background: linear-gradient(180deg, rgba(8, 179, 136, 0.15) 0%, rgba(22, 101, 192, 0.15) 100%); */\n  background: linear-gradient(180deg, rgb(7 33 44) 0%, rgb(9 23 51) 100%);\n  padding: 12px 0;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 111;\n}\n\nheader.main-header .row {\n  justify-content: space-between;\n  align-items: center;\n}\n\nheader.main-header .site-logo {\n  width: 200px;\n}\n\nheader.main-header .site-logo a {\n  display: inline-block;\n}\n\nheader.main-header .site-logo a img {\n  max-width: 100%;\n  max-height: 42px;\n  object-fit: contain;\n}\nheader.main-header .site-navbar {\n  width: calc(100% - 200px);\n}\nheader.main-header .site-navbar ul {\n  display: flex;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  justify-content: flex-end;\n}\nheader.main-header .site-navbar ul li a{\n  display: inline-block;\n  text-decoration: none;\n  color: rgba(255, 255, 255, 0.80);\n  font-size: 16px;\n  font-weight: 500;\n  padding: 12px;\n  transition: all 0.2s;\n}\nheader.main-header .site-navbar ul li a:hover{color: #08B388;}\n\n\n.newsletter-form {\n}\n.newsletter-form form {\n  position: relative;\n  max-width: 450px;\n  margin-top: 30px;\n}\n.newsletter-form form input {\n  width: 100%;\n  height: 50px;\n  background: transparent;\n  border: 1px solid #fff;\n  outline: none;\n  border-radius: 24px;\n  color: #fff;\n  font-size: 16px;\n  padding: 0 25px;\n}\n.newsletter-form form button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  background: #08b388;\n  border: none;\n  outline: none;\n  color: #fff;\n  font-size: 16px;\n  padding: 0 20px;\n  border-radius: 0px 25px 25px 0px;\n}\n.newsletter-form form p {\n  margin: 10px 0px 0px;\n  padding: 0px;\n}\n\n/* ////////////////////////////////////////////////////////////// */\n\n.container {\n  max-width: 1170px !important;\n  width: 100%;\n}\n\n.section-seprator {\n  text-align: center;\n  border-top: solid 2px rgba(93, 95, 239, 0.20);\n}\n\n.section-seprator h4 {\n  display: inline-block;\n  margin: 0 0 0;\n  border-radius: 4px;\n  background: rgba(93, 95, 239, 0.20);\n  color: #08B388;\n  font-size: 20px;\n  font-weight: 600;\n  padding: 6px 22px;\n}\n\n.common-content-section {\n  padding: 100px 0;\n}\n\n.common-content .label-tag {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 12px 12px 12px 0px;\n  background: rgba(93, 95, 239, 0.20);\n  color: #08B388;\n  font-size: 20px;\n  font-weight: 600;\n  padding: 11px 20px 8px;\n}\n\n.common-content .label-tag img {\n  margin-right: 6px;\n  transform: translateY(-2px);\n}\n\n.common-content h1 {\n  margin: 22px 0 0px;\n  color: #D9D9D9;\n  font-size: 40px;\n  font-weight: 500;\n  line-height: 1;\n  max-width: 475px;\n}\n\n.common-content h2 {\n  margin: 22px 0 0px;\n  color: #D9D9D9;\n  font-size: 36px;\n  font-weight: 500;\n  line-height: 1;\n  max-width: 420px;\n}\n\n.common-content p {\n  margin: 26px 0 0;\n  color: #D9D9D9;\n  font-family: League Spartan;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.common-content .site-btn {\n  display: inline-block;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 20px;\n  color: #fff;\n  border-radius: 12px;\n  background: #08B388;\n  line-height: 1.2;\n  padding: 13px 20px 10px;\n  margin-top: 30px;\n  transition: all 0.4s;\n}\n\n.common-content .site-btn:hover{\n  transform: scale(1.08);\n}\n\n.app-buttons {\n  margin-top: 40px;\n  display: flex;\n  align-items: center;\n}\n\n.app-buttons a {\n  display: inline-block;\n  text-decoration: none;\n  margin-right: 12px;\n  transition: all 0.4s;\n}\n\n.app-buttons a:hover{\n  transform: scale(1.08);\n}\n\n.app-buttons a:last-child{margin-right: 0;}\n\n.app-buttons a img {\n  max-width: 193px;\n  width: 100%;\n}\n\n.app-slider-inner {\n  width: 100%;\n}\n\n.app-slider-inner .container-fluid {\n  max-width: 1400px;\n  padding: 0 30px;\n}\n\n.app-slider-inner .slick-list {\n  padding: 50px 0 !important;\n}\n\n.app-slider-text {\n  padding-bottom: 50px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.app-slider-text h2 {\n  margin: 0 auto;\n  color: #D9D9D9;\n  font-size: 36px;\n  font-weight: 500;\n  line-height: 1;\n  max-width: 548px;\n}\n\n.app-slider-text p {\n  margin: 26px 0 0;\n  color: #D9D9D9;\n  font-family: League Spartan;\n  font-size: 25px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.2;\n}\n\n.app-slider-wrapper {\n  padding: 100px 0 100px;\n}\n\n.app-img-item {\n  padding: 0 15px;\n  text-align: center;\n}\n.app-img-item img{\n  display: inline-block !important;\n  transition: all 0.4s;\n}\n\n.app-slider-inner .slick-center .app-img-item img{\n  transform: scale(1.15);\n}\n\n/* ////////////////////////////////////////////////////// */\n\nfooter.main-footer {\n  background: #0C141D;\n  padding: 60px 0;\n}\n\n.footer-cl-01 {\n  max-width: 400px;\n}\n\n.footer-cl-01 img {}\n\n.footer-cl-01 p {\n  color: rgba(255, 255, 255, 0.80);\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.3;\n  margin: 20px 0 0;\n}\n\n.footer-cl-02 {}\n\n.footer-cl-02 ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.footer-cl-02 ul li {\n  padding-bottom: 8px;\n}\n\n.footer-cl-02 ul li a {\n  display: inline-block;\n  text-decoration: none;\n  font-size: 16px;\n  color: #fff;\n  font-weight: 300;\n  line-height: 1.2;\n  padding: 0;\n  transition: all 0.2s;\n}\n\n.footer-cl-02 ul li a:hover{color: #08B388;}\n\nfooter.main-footer h3 {\n  color: #fff;\n  margin: 0 0 0;\n  font-size: 40px;\n  line-height: 1;\n  font-weight: 500;\n  padding-bottom: 20px;\n}\n\n.footer-cl-03 {}\n\n.footer-cl-03 ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.footer-cl-03 ul li {\n  padding-bottom: 11px;\n}\n\n.footer-cl-03 ul li a {\n  display: inline-block;\n}\n\n.footer-cl-03 ul li a img {\n  max-width: 160px;\n}\n\n.footer-copyright {\n  background: #0C141D;\n  border-top: 2px solid #06091a;\n  padding: 20px 0;\n}\n\n.footer-copyright p {\n  margin: 0 0 0;\n  color: rgba(255, 255, 255, 0.80);\n  font-weight: 300;\n  font-size: 14px;\n}\n\n@media (max-width: 991.98px){\n\n  .common-content-section {\n    padding: 60px 0;\n    text-align: center;\n  }\n  .common-content {\n    padding-top: 40px;\n  }\n  .common-large-img img {\n    max-width: 600px;\n    width: 100%;\n  }\n  .common-content h1,\n  .common-content h2,\n  .footer-cl-01{\n    max-width: 100%;\n  }\n  .app-buttons{\n    justify-content: center;\n  }\n  .footer-cl-02,\n  .footer-cl-03{\n    padding-top: 40px;\n  }\n  .app-slider-wrapper {\n    padding: 60px 0 60px;\n  }\n\n}\n\n@media (max-width: 767.98px){\n\n  .common-content h1,\n  .common-content h2,\n  .app-slider-text h2{\n    font-size: 32px;\n  }\n  .app-slider-text p{\n    font-size: 18px;\n  }\n  header.main-header .site-navbar{\n    position: fixed;\n    top: 0;\n    left: -300px;\n    bottom: 0;\n    width: 300px;\n    z-index: 555;\n    height: 100%;\n    background: #000;\n    padding-top: 40px;\n    transition: all 0.4s;\n  }\n  header.main-header .site-navbar.active{\n    left: 0;\n  }\n  header.main-header .site-navbar ul{\n    display: block;\n  }\n  header.main-header .mobile-menu-close {\n    display: block !important;\n    position: absolute;\n    top: 10px;\n    right: 12px;\n    color: #fff;\n    cursor: pointer;\n  }\n\n  .mobile-menu-close svg {\n    width: 20px;\n    height: 20px;\n  }\n  header.main-header .mobile-menu-button{\n    display: block !important;\n    width: calc(100% - 200px);\n    text-align: right;\n    cursor: pointer;\n    color: #fff;\n  }\n  header.main-header .mobile-menu-button svg{\n    width: 25px;\n    height: 25px;\n  }\n  header.main-header .site-navbar ul li a{\n    display: block;\n  }\n\n}\n\n@media (max-width: 576.98px){\n\n  \n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
